// extracted by mini-css-extract-plugin
export default {"root":"VI2BNGJaZgFMhgYuxkbU","placeHolderShimmer":"djiAFx4Ue8YC2xOZ29bE"};